export function ProcessObjectTypeComponent(props: { type: string }) {
  switch (props.type) {
    case 'revenue':
      return <span style={{color: 'blue'}}>Receita</span>;
    case 'cost':
      return  <span style={{color: 'red'}}>Despesa</span>;
    default:
      return <>{props.type}</>;
  }
}